import { catalog } from "../i18n.js";

/** The chat (components/Chat.tsx): bubbles, cards, the status line. */
export const CHAT = catalog(
  {
    openPicture: "Open the picture",
    attachment: "attachment",
    openAgent: (name: string) => `Open ${name}`,
    mentionOpens: (mention: string, name: string) => `${mention}, open ${name}`,
    messageOptions: "Message options",
    reply: "Reply",
    copyText: "Copy text",
    copied: "Copied",
    you: "You",
    quotedPicture: "Picture",
    quotedFile: "File",
    repliedToEarlier: "Replying to an earlier message",
    showRepliedMessage: "Show the message this answers",
    fromWhatsApp: "From your phone, on WhatsApp",
    alsoSentToPhone: "Also sent to your phone",
    botReacted: "the bot reacted",
    youReacted: "you reacted",

    waitingForYou: "Waiting for you",
    contactAnswered: "Answered",
    contactSetAside: "Set aside",
    meetingHolding: "Holding the time",
    meetingBooked: "Booked",
    meetingDeclined: "Declined",
    whatsAppMeeting: "WhatsApp · Meeting",
    contactQuestion: "Question",
    contactMessage: "Message",
    contactUrgent: " · Urgent",
    youSaid: "You said:",
    openInCalendar: "Open in your calendar",
    meetingWordPlaceholder: "Add a word to pass on (optional)",
    meetingWordLabel: (name: string) => `A word for ${name}`,
    booking: "Booking…",
    bookIt: "Book it",
    decline: "Decline",
    answerPlaceholder: "Your answer, for the bot to pass on",
    replyPlaceholder: "A reply, for the bot to pass on",
    answerLabel: (name: string) => `Answer ${name}`,
    send: "Send",
    setAside: "Set aside",

    approvalNeeded: "Approval needed",
    approvalApproved: "Approved",
    approvalDeclined: "Declined",
    approvalExpired: "Expired unanswered",
    suggestedRule: "Suggested rule for your checks:",
    approve: "Approve",
    approveAlwaysAbout: "Adds the suggested rule to your always-allow list, then approves",
    approveAlways: "Approve and always allow",
    newMessageCancels: "Sending a new message cancels it.",

    computer: "Computer",
    handoffWaiting: "Action needed",
    handoffDone: "Done",
    handoffSkipped: "Skipped",
    handoffAnswered: "Answered",
    takeOverAbout: "Open the screen and use it yourself",
    takeOver: "Take over",
    imDone: "I'm done",
    skipAbout: "Hand the screen back without doing the step; the bot carries on without it",
    skip: "Skip",

    waitingForApproval: (who: string) => `${who} is waiting for your approval`,
    typing: (who: string) => `${who} is typing`,
    busyWith: (who: string, activity: string) => `${who} is ${activity}…`,
    thinking: (who: string) => `${who} is thinking…`,

    peerTo: "to",
    betweenBots: "Between bots",

    notSent: "Not sent",
    tryAgain: "Try again",
    remove: "Remove",

    loadingEarlier: "Loading earlier messages…",
    scrollForEarlier: "Scroll up for earlier messages",
    sayHello: "Say hello.",
    jumpUnreadLabel: "New messages; jump to the latest",
    jumpLabel: "Jump to the latest message",
    jumpUnreadTitle: "New messages below",
    jumpTitle: "To the latest message",
  },
  {
    openPicture: "Buka gambar",
    attachment: "lampiran",
    openAgent: (name) => `Buka ${name}`,
    mentionOpens: (mention, name) => `${mention}, buka ${name}`,
    messageOptions: "Opsi pesan",
    reply: "Balas",
    copyText: "Salin teks",
    copied: "Disalin",
    you: "Kamu",
    quotedPicture: "Gambar",
    quotedFile: "File",
    repliedToEarlier: "Membalas pesan sebelumnya",
    showRepliedMessage: "Lihat pesan yang dibalas",
    fromWhatsApp: "Dari HP kamu, lewat WhatsApp",
    alsoSentToPhone: "Juga dikirim ke HP kamu",
    botReacted: "bot memberi reaksi",
    youReacted: "kamu memberi reaksi",

    waitingForYou: "Menunggu kamu",
    contactAnswered: "Dijawab",
    contactSetAside: "Disisihkan",
    meetingHolding: "Waktunya ditahan",
    meetingBooked: "Terjadwal",
    meetingDeclined: "Ditolak",
    whatsAppMeeting: "WhatsApp · Rapat",
    contactQuestion: "Pertanyaan",
    contactMessage: "Pesan",
    contactUrgent: " · Mendesak",
    youSaid: "Kata kamu:",
    openInCalendar: "Buka di kalender kamu",
    meetingWordPlaceholder: "Tambahkan pesan untuk diteruskan (opsional)",
    meetingWordLabel: (name) => `Pesan untuk ${name}`,
    booking: "Menjadwalkan…",
    bookIt: "Jadwalkan",
    decline: "Tolak",
    answerPlaceholder: "Jawabanmu, nanti diteruskan bot",
    replyPlaceholder: "Balasanmu, nanti diteruskan bot",
    answerLabel: (name) => `Jawab ${name}`,
    send: "Kirim",
    setAside: "Sisihkan",

    approvalNeeded: "Butuh persetujuan",
    approvalApproved: "Disetujui",
    approvalDeclined: "Ditolak",
    approvalExpired: "Kedaluwarsa tanpa jawaban",
    suggestedRule: "Saran aturan untuk pemeriksaanmu:",
    approve: "Setujui",
    approveAlwaysAbout: "Menambahkan aturan yang disarankan ke daftar selalu diizinkan, lalu menyetujui",
    approveAlways: "Setujui dan selalu izinkan",
    newMessageCancels: "Mengirim pesan baru akan membatalkannya.",

    computer: "Komputer",
    handoffWaiting: "Perlu tindakan",
    handoffDone: "Selesai",
    handoffSkipped: "Dilewati",
    handoffAnswered: "Dijawab",
    takeOverAbout: "Buka layar dan pakai sendiri",
    takeOver: "Ambil alih",
    imDone: "Sudah selesai",
    skipAbout: "Kembalikan layar tanpa mengerjakan langkah ini; bot lanjut tanpanya",
    skip: "Lewati",

    waitingForApproval: (who) => `${who} menunggu persetujuanmu`,
    typing: (who) => `${who} sedang mengetik`,
    busyWith: (who, activity) => `${who} sedang ${activity}…`,
    thinking: (who) => `${who} sedang berpikir…`,

    peerTo: "ke",
    betweenBots: "Antar bot",

    notSent: "Tidak terkirim",
    tryAgain: "Coba lagi",
    remove: "Hapus",

    loadingEarlier: "Memuat pesan sebelumnya…",
    scrollForEarlier: "Gulir ke atas untuk pesan sebelumnya",
    sayHello: "Sapa dulu, yuk.",
    jumpUnreadLabel: "Ada pesan baru; lompat ke yang terbaru",
    jumpLabel: "Lompat ke pesan terbaru",
    jumpUnreadTitle: "Ada pesan baru di bawah",
    jumpTitle: "Ke pesan terbaru",
  },
);

/** The stamps between runs of messages (chat-time.ts). */
export const CHAT_TIME = catalog(
  {
    today: (time: string) => `Today ${time}`,
    yesterday: (time: string) => `Yesterday ${time}`,
    dayAndTime: (day: string, time: string) => `${day}, ${time}`,
  },
  {
    today: (time) => `Hari ini ${time}`,
    yesterday: (time) => `Kemarin ${time}`,
    dayAndTime: (day, time) => `${day}, ${time}`,
  },
);

/** The composer's @ list (mentions.ts). */
export const MENTIONS = catalog(
  {
    everyoneDetail: "Everyone in the group answers",
  },
  {
    everyoneDetail: "Semua anggota grup menjawab",
  },
);

/** A form the bot sends into the chat (components/FormCard.tsx). */
export const FORM_CARD = catalog(
  {
    waiting: "waiting for you",
    submitted: "answered",
    cancelled: "dismissed",
    expired: "closed unanswered",
    yes: "yes",
    no: "no",
    choose: "Choose…",
    send: "Send",
    dismiss: "Dismiss",
    dismissAbout: "The bot is told you dismissed it and carries on without these details",
  },
  {
    waiting: "menunggu kamu",
    submitted: "dijawab",
    cancelled: "diabaikan",
    expired: "ditutup tanpa jawaban",
    yes: "ya",
    no: "tidak",
    choose: "Pilih…",
    send: "Kirim",
    dismiss: "Abaikan",
    dismissAbout: "Bot diberi tahu kamu mengabaikannya, lalu lanjut tanpa detail ini",
  },
);
